/** One note-writing box.
 *
 * Kept as a named seam over RichTextEditor so the notebook screen does not
 * care how formatting is implemented. It previously wrapped a plain
 * textarea with a `**` toolbar and a preview panel underneath; the client
 * found the markers confusing, so the box now shows real formatting and the
 * preview is gone — there is nothing left to preview.
 */
import { RichTextEditor } from "./RichTextEditor";

export interface NoteEditorProps {
  value: string;
  onChange: (next: string) => void;
  label: string;
  placeholder?: string;
  rows?: number;
}

export function NoteEditor({
  value, onChange, label, placeholder, rows = 3,
}: NoteEditorProps) {
  return (
    <RichTextEditor
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      // `rows` was a textarea measure; keep the callers' intent as a height.
      minRem={Math.max(4, rows * 1.9)}
    />
  );
}
